<template lang="pug">
  div
    form(ref="saveHtmlForm" :action="action_url" method="POST" @submit.prevent="onSave")
      div.d-flex
        input#html_name.form-control.mr-2(style="width: 75%;", type='text', name='html_name', v-model='html_name', placeholder='名前（例：改修前LP）')
        input(type="hidden" name="_method" value="PATCH")
        button.btn.btn-success.btn-sm(type='submit') 保存
      span.text-sm 保存は5分程度完了します。保存後、現在のWebサイトのデザイン変更後も保存した変更前のデザインを選択・表示できます。
    div.d-flex.align-items-center
      UpgradeUpperMaster(v-if="is_upgrade_upper_master_modal", @close-modal="is_upgrade_upper_master_modal = false")
  </template>

<script>
//libs
import UpgradeUpperMaster from "./modals/upgrade_upper_master.vue";

export default {
  props: {
    action_url: {type: String, default: "" },
    is_upper_master: {type: Boolean, default: false },
  },
  methods: {
    onSave(){
      if (!this.is_upper_master){
        this.is_upgrade_upper_master_modal = true
        return
      }else{
        this.$refs.saveHtmlForm.submit()
      }
    },
  },
  data(){
    return {
      is_upgrade_upper_master_modal: false,
      html_name: "",
    }
  },
  components: {
    UpgradeUpperMaster,
  },
}
</script>

